module.exports = {
      id: "youtube-usage",
      viewBox: "0 0 64 45",
      url: __webpack_public_path__ + "img/symbols.e4df9320ab0fa712c143543fa64d490c.svg#youtube",
      toString: function () {
        return this.url;
      }
    }